import axios from 'axios'
import plugins from '../utils/plugins'

const API = axios.create({
    headers: {
    },
    timeout: 30000, // request timout
    baseURL: "https://xctrader.com/api",
});

API.interceptors.request.use(
    config => {
        config.headers.token = plugins.getLocal('tokenValue')
        config.headers.lang = 'en'
        return config //To handle the return data of Config, then send request to EP
    },
    error => { // To execute the code when error occurs
        // console.log(error)
        return Promise.reject(error)
    }
)
API.interceptors.response.use(function (response) {
    if (response.data.code === 0 || response.status === 200) {//To handle the specific logic by dividing the 0 || 200 status
        //     if (response.data.code === 330006 || response.data.code === 330001) {
        //         //auction 被 ban或者登录被ban
        //         store.commit('updateBanedAuction', true)
        //         return response.data
        //     }
        //     else if (response.data.code in errorMsg) {
        //         message.error(errorMsg[response.data.code])
        //     } else {
        return response.data
        // }
    } else {
        //抛错
        message.error(i18n.global.t('errorText'))
        return Promise.reject(response.data)
    }
}, function (error) {
    if (error?.response?.status === 401 && !isFromAppNew()) {
        store.commit('reset')
        plugins.deleteLocal('userToken')
        plugins.deleteLocal('userInfo')
        sessionStorage.removeItem('metamaskAccount')
        sessionStorage.removeItem('avatarUrl')

        if (web3auth && web3auth.connected) {
            web3auth.logout()
            sessionStorage.removeItem('address')
        }
        router.push('/login')
    }
    return Promise.reject(error)
})

export default API